import { FREE_COURT_SLUG, INDOOR_COURT_SLUG, OUTDOOR_COURT_SLUG } from 'constants/pages';
import type {
  GetCityClinicsQuery,
  GetCityCoachesQuery,
  GetCityPageContentByCitySlugQuery,
  GetCityVenuesByCitySlugQuery,
  GetTournamentsForStateQuery,
  GetVenuesByGeoQuery,
} from 'types/generated/server';
import TagFree from 'svg/TagFree';
import TagIndoor from 'svg/TagIndoor';
import TagOutdoor from 'svg/TagOutdoor';

export const tagLinks = {
  [FREE_COURT_SLUG]: {
    name: 'Free',
    slug: FREE_COURT_SLUG,
    Svg: TagFree,
  },
  [INDOOR_COURT_SLUG]: {
    name: 'Indoor',
    slug: INDOOR_COURT_SLUG,
    Svg: TagIndoor,
  },
  [OUTDOOR_COURT_SLUG]: {
    name: 'Outdoor',
    slug: OUTDOOR_COURT_SLUG,
    Svg: TagOutdoor,
  },
};

export type TagLinkKey = keyof typeof tagLinks;

export interface Props {
  idOrSlug: string;
  city: GetCityVenuesByCitySlugQuery['cities'][0];
  metaTitle: string;
  metaDescription: string;
  availableTags?: TagLinkKey[];
  tagName?: string;
  tagSlug?: string;
  jsonLd: string;
  nearbyVenues: Omit<GetVenuesByGeoQuery['venues'][0], 'city'>[];
  sport?: string;
  tournaments?: GetCityPageContentByCitySlugQuery['cities'][0]['events'];
  stateTournaments?: GetTournamentsForStateQuery['events'];
  coaches?: GetCityPageContentByCitySlugQuery['cities'][0]['coaches'];
  topCoaches?: GetCityCoachesQuery['userProfiles'];
  topClinics?: GetCityClinicsQuery['lessons'];
  coachStarterProfiles?: GetCityPageContentByCitySlugQuery['cities'][0]['coachStarterProfiles'];
  groups?: GetCityPageContentByCitySlugQuery['cities'][0]['groups'];
  noIndex?: boolean;
}
